<template>
  <section
    id="oppreg-form"
    style ="background:#fff;border:0 solid lightgray;margin:15px 10px; padding:15px 15px" >
    <v-form>
      <v-container>
        <v-progress-linear
          v-slot:progress
          v-if="registering"
          color="orange"
          indeterminate/>
        <strong>NOTE: All fields with <span class="required">*</span> are required. {{ oppType==='gainwell' ? 'Please provide Gainwell Customer details when applicable' : '' }}</strong>
        <v-layout
          column
          wrap v-if="oppType === '' ">
          <v-flex
            xs12
            sm6
            md3>
            <label>Opportunity Name: <span class="required">*</span></label>
            <v-text-field
              v-model="workloadForm.oppFields.opportunity.SFDC_Oppty_Name"
              :disabled="!customId"
              :placeholder=" manualRegistration ? 'Please enter the Opportunity Name from Salesforce' : 'OpportunityName from SFDC API'"
              >
              <!-- <template slot="label">
                <span v-html="`Opportunity Name <span class='required'>*</span>`"/>
              </template> -->
            </v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex md6>
            <label>Salesforce Sales Stage</label>
            <v-text-field
              v-model.lazy="workloadForm.oppFields.opportunity.SFDC_Sales_Stage"
              readonly/>
          </v-flex>
          <v-flex md6>&nbsp;
            <p v-if="validateStage" class="required">AWS does not approve submission of registrations with a Lost or Not Pursued sales stage. <br/>Please contact <a href="mailto:aws-oppreg@dxc.com">aws-oppreg@dxc.com</a> for further help if needed.</p>
          </v-flex>
        </v-layout>
        <v-layout
          row
          wrap>
          <v-flex xs6>
            <label>{{ oppForm.label.Customer_Name }}: <span class="required">*</span></label>
            <v-text-field
              v-validate="'required'"
              v-model="workloadForm.oppFields.opportunity.Customer_Name"
              :disabled="!customId && isCustName"
              :placeholder="oppForm.placeholder.Customer_Name"
              :readonly="oppregStep==='viewOppForm'"
              @change="onCustomerNameChange"
            />
          </v-flex>
          <v-flex xs6>
            <label>Region: <span class="required">*</span></label>
            <v-select
              v-validate="'required'"
              :items="regions"
              v-model="workloadForm.oppFields.account.Customer_Region"
              :readonly="oppregStep==='viewOppForm'"
              attach
              name="region"
              data-vv-name="Region"
              data-vv-validate-on="blur"
              item-text="region"
              placeholder="Select a Region"
            />
            <!-- <v-text-field
              v-else
              readonly
              v-validate="'required'"
              v-model="workloadForm.oppFields.account.Customer_Region"
              name="region"
              data-vv-name="region"
              data-vv-validate-on="blur"
              /> -->
          </v-flex>
        </v-layout>
        <v-layout
          column
          wrap>
          <v-flex
            xs12
            sm6
            md3>
            <label>{{ oppForm.label.Customer_Street }}: <span class="required">*</span></label>
            <v-text-field
              v-validate="{ required: true, regex: /^[\w\-\s]+$/ }"
              v-model.lazy="workloadForm.oppFields.account.Customer_Address"
              :error-messages="errors.collect('Customer_Address')"
              :placeholder="oppForm.placeholder.Customer_Street"
              :readonly="oppregStep==='viewOppForm'"
              data-vv-name="Customer_Address"
              data-vv-validate-on="blur"
              required
              clearable />
          </v-flex>
        </v-layout>
        <v-layout
          row
          wrap>
          <v-flex xs6>
            <label>{{ oppForm.label.Customer_City }}: <span class="required">*</span></label>
            <v-text-field
              v-validate="{ required: true, regex: /^[\w\-\s]+$/ }"
              v-model.lazy="workloadForm.oppFields.account.Customer_City"
              :error-messages="errors.collect('Customer_City')"
              :placeholder="oppForm.placeholder.Customer_City"
              :readonly="oppregStep==='viewOppForm'"
              class="customer-city"
              data-vv-name="Customer_City"
              data-vv-validate-on="blur"
              required
              clearable />
          </v-flex>
          <v-flex xs6>
            <label>Country: <span class="required">*</span></label>
            <v-text-field
              v-validate="'required'"
              v-model.lazy="workloadForm.oppFields.opportunity.Country"
              :error-messages="errors.collect('Country')"
              :readonly="oppregStep==='viewOppForm'"
              placeholder="Select a Country"
              data-vv-name="Country"
              data-vv-validate-on="blur"
              required
            />

            <!-- <v-select
              v-validate="'required'"
              :items="filterCountryByRegion"
              v-model.lazy="workloadForm.oppFields.opportunity.Country"
              :error-messages="errors.collect('Country')"
              name="country"
              item-text="country"
              placeholder="Select a Country"
              data-vv-name="Country"
              data-vv-validate-on="blur"
              required
              attach /> -->
          </v-flex>
        </v-layout>

        <v-layout
          row
          wrap>
          <v-flex xs6>
            <label>State/Province: <span
              v-if="isStateRequired"
              class="required">*</span></label>
            <v-text-field
              v-validate="{rules:{required: isStateRequired}, regex: /^[\w\-\s]+$/ }"
              v-model.lazy="workloadForm.oppFields.account.Customer_State"
              :error-messages="errors.collect('State_Province')"
              :readonly="oppregStep==='viewOppForm'"
              class="state-province"
              placeholder="User Entry"
              data-vv-name="State_Province"
              data-vv-validate-on="blur"
              clearable />
          </v-flex> 
          <v-flex xs6>
            <label>Postal Code: <span class="required">*</span></label>
            <v-text-field
              v-validate="'required'"
              v-model.lazy="workloadForm.oppFields.account.Customer_PC"
              :error-messages="errors.collect('Postal_Code')"
              :readonly="oppregStep==='viewOppForm'"
              class="postal-code"
              placeholder="User Entry"
              data-vv-name="Postal_Code"
              data-vv-validate-on="blur"
              required

              clearable />
          </v-flex>
        </v-layout>

        <v-layout
          row
          wrap>
          <v-flex
            xs12
            sm6
            md6>
            <label>{{ oppForm.label.Customer_Url }}: <span class="required">*</span></label>
            <v-text-field
              v-validate="{url: {require_protocol: false }}"
              v-model.lazy="workloadForm.oppFields.account.Customer_URL"
              :error-messages="errors.collect('Customer_URL')"
              :placeholder="oppForm.placeholder.Customer_Url"
              :readonly="oppregStep==='viewOppForm'"
              data-vv-name="Customer_URL"
              data-vv-validate-on="blur"
              required
              clearable />
          </v-flex>
          <v-flex>
          <p class="customer-url-note">AWS tests the Customer URL and will reject<br/> registration if  link is inactive/inaccurate.</p>
          </v-flex>
          <v-flex
            v-if="manualRegistration"
            xs12
            md6>
            <v-menu
              v-model="signDateMenu"
              :close-on-content-click="false"
              lazy
              transition="scale-transition"
              full-width
              min-width="290px"

            >
              <template v-slot:activator="{ on }">
                <label for="">Sign Date: <span class="required">*</span></label>
                <v-text-field
                  v-model="signDate"
                  v-on="on"
                  readonly
                />
              </template>
              <v-date-picker
                v-model="signDate"
                @input="signDateMenu = false"/>
            </v-menu>
          </v-flex>
          <!-- <v-flex
            xs12
            sm6
            md6
            v-if = "oppType === '' ">
            <label>Is this opportunity the result of an RFP/RFI? <span class="required">*</span></label>
            <v-radio-group
              v-model="workloadForm.oppFields.header.RFI_RFP"
              :mandatory="false"
              class="radio-button"
              row>
              <v-radio
                :value="1"
                label="Yes"
                name="RFI_RFP"
                color="orange" />
              <v-radio
                :value="0"
                label="No"
                name="RFI_RFP"
                color="orange" />
            </v-radio-group>
          </v-flex> -->
        </v-layout>
      </v-container>
      <v-container >
        <v-layout attach>
          <v-flex md6>
            <label>Industry Vertical: <span class="required">*</span></label>
            <v-autocomplete
              v-model="calculatedIndustryVertical"
              :hint="'Select the client\'s industry vertical. Click the icon on the right to view the full list'"
              :items="industryVerticalList"
              :error-messages="errors.collect('IndustryVertical')"
              :placeholder="oppForm.placeholder.IndustryVertical"
              :readonly="oppregStep==='viewOppForm'"
              data-vv-name="IndustryVertical"
              data-vv-validate-on="blur"
              required
              persistent-hint
              style="margin-top: 0; padding-top: 5px"
              open-on-clear
              clearable
              attach
            >
              <template v-slot:selection="data">
                {{ data.item }}
              </template>
              <template v-slot:append-outer>
                <v-icon
                  color="orange"
                  @click="onFullView"
                  v-text="'mdi-view-list'"
                ></v-icon>
              </template>
            </v-autocomplete>
          </v-flex>
          <v-flex md6 v-if="workloadForm.oppFields.opportunity.IndustryVertical === 'Other'">
            <label>Specify Other Industry Vertical: <span class="required">*</span></label>
            <v-text-field
              v-validate="workloadForm.oppFields.opportunity.IndustryVertical === 'Other' ? 'required' : ''"
              v-model="workloadForm.oppFields.opportunity.IndustryVerticalOther"
              :error-messages="errors.collect('IndustryVerticalOther')"
              :placeholder="oppForm.placeholder.IndustryVerticalOther"
              data-vv-name="IndustryVerticalOther"
              data-vv-validate-on="blur"
              required
              style="margin-top: 0; padding-top: 5px"
              clearable />
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex md6>
            <label>SF Opp Owner Email</label>
            <v-text-field
              v-model.lazy="workloadForm.oppFields.opportunity.Owner_Email"
              readonly/>
          </v-flex>
          <v-flex md6>
            <label>SF Opp Owner Name</label>
            <v-text-field
              v-model.lazy="workloadForm.oppFields.opportunity.Owner_Name"
              readonly/>
          </v-flex>
        </v-layout>
        
        <!-- <v-layout>
          <v-checkbox
                v-model="registrationStatus"
                color="orange"
                label="Details Complete?"
                @change="onCompleteRegistration"
              />
        </v-layout> -->
      </v-container>
      <v-container>
        <v-layout
          row
          wrap >
          <v-layout
            column
            wrap
            align-center
            justify-center>
            <v-flex
              xs12
              sm12
              md12
              xl12 >
              <v-btn color="success" v-if="oppType==='' && oppregStep !== 'viewOppForm'" @click="goBack()">GO BACK</v-btn>
              <v-btn
                v-if="oppregStep !== 'viewOppForm'"
                :loading="formSubmitting"
                :disabled="!regFormComplete"
                class="opp-btn"
                color="warning"
                @click="onSubmit">Continue Adding Workload</v-btn>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-container>
    </v-form>
    <v-dialog
      v-model="industryVerticalListFullView"
      large
      persistent
      scrollable
      max-width="1000px">
      <v-card>
        <v-card-title>Industry Vertical List</v-card-title>
        <v-container>
          <v-layout>
            <v-flex>
              <ul>
                <li v-for="industryName in industryVerticalListColumn1" >
                  {{industryName}}
                </li>
              </ul>
            </v-flex>
            <v-flex>
              <ul>
                <li v-for="industryName in industryVerticalListColumn2" >
                  {{industryName}}
                </li>
              </ul>
            </v-flex>
            <v-flex>
              <ul>
                <li v-for="industryName in industryVerticalListColumn3" >
                  {{industryName}}
                </li>
              </ul>
            </v-flex>
          </v-layout>
        </v-container>
        <v-divider />
        <v-card-actions style="text-align: right">
          <v-spacer/>
          <v-btn @click="industryVerticalListFullView = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>
<script>
import { Validator } from 'vee-validate'
import { mapMutations, mapState, mapActions } from 'vuex'
import { generateRegistrationID, getCountries } from '@/utils/helper'

export default {
  data () {
    return {
      SFDC_ID: '',
      items: ['Storage', 'Database', 'App Services', 'Compute', 'Network'],
      // regions: ['All Region', 'AMS', 'ANZ', 'Asia', 'NCE', 'SE', 'UKIIMEA', 'APAC'],
      // regions: ['APAC', 'AMS', 'EMEA'],
      regions: ['Americas', 'UKI', 'Europe', 'APJ-MEA', 'Luxoft'],
      value: [''],
      dictionary: {
        custom: {
          SFDC_ID: {
            required: () => 'SFDC ID is empty'
          },
          Customer_Street: {
            required: () => 'Customer Street is empty'
          },
          Customer_City: {
            required: () => 'Customer City is empty'
          },
          Countries: {
            required: () => 'Choose a Country'
          },
          State_Province: {
            required: () => 'State / Province is empty'
          },
          Postal_Code: {
            required: () => 'Postal Code is empty'
          },
          Customer_URL: {
            required: () => 'Customer URL is empty'
          },
          IndustryVerticalOther: {
            required: () => 'Industry Vertical Other is empty'
          }
        }
      },
      countries: getCountries(),
      industryVerticalList: ['Aerospace', 'Agriculture', 'Automotive','Computers & Electronics','Consumer Goods','Education','Financial Services','Gaming','Government','Healthcare','Hospitality','Life Sciences','Manufacturing','Marketing & Advertising','Media & Entertainment','Mining','Non-Profit Organization','Energy - Oil & Gas','Other','Energy - Power & Utilities','Professional Services','Real Estate & Construction','Retail','Software & Internet','Telecommunications','Transportation & Logistics','Travel','Wholesale & Distribution'],
      industryVerticalListFullView: false,
      signDateMenu: false
    }
  },
  computed: {
    ...mapState('user/requestOppreg', ['workloadForm','oppregStep', 'oppType','oppForm','customId', 'isCustName','registering', 'submitting', 'formSubmitting', 'isSubmitted', 'recordNotFound', 'manualRegistration']),
    regFormComplete () {
      
      if (this.workloadForm.oppFields.opportunity.IndustryVertical === 'Other' && !this.workloadForm.oppFields.opportunity.IndustryVerticalOther) {
        return false
      }

      if (this.workloadForm.oppFields.account.Customer_Region === 'United States of America') {
        if (this.manualRegistration) {
          return this.workloadForm.oppFields.opportunity.SFDC_Oppty_Name &&
          this.workloadForm.oppFields.opportunity.Customer_Name &&
          this.workloadForm.oppFields.account.Customer_Region &&
          this.workloadForm.oppFields.account.Customer_Address &&
          this.workloadForm.oppFields.account.Customer_City &&
          this.workloadForm.oppFields.opportunity.Country &&
          this.workloadForm.oppFields.opportunity.Customer_State &&
          this.workloadForm.oppFields.account.Customer_PC &&
          this.workloadForm.oppFields.account.Customer_URL &&
          this.workloadForm.oppFields.opportunity.IndustryVertical &&
          this.workloadForm.oppFields.opportunity.SignDate &&
          (!this.errors.items.length)
        } else if (this.oppType ===''){
          return this.workloadForm.oppFields.opportunity.SFDC_Oppty_Name &&
          this.workloadForm.oppFields.opportunity.Customer_Name &&
          this.workloadForm.oppFields.account.Customer_Region &&
          this.workloadForm.oppFields.account.Customer_Address &&
          this.workloadForm.oppFields.account.Customer_City &&
          this.workloadForm.oppFields.opportunity.Country &&
          this.workloadForm.oppFields.opportunity.Customer_State &&
          this.workloadForm.oppFields.account.Customer_PC &&
          this.workloadForm.oppFields.account.Customer_URL &&
          this.workloadForm.oppFields.opportunity.IndustryVertical &&
          // (this.workloadForm.oppFields.header.RFI_RFP === 1 || this.workloadForm.oppFields.header.RFI_RFP === 0) &&
          (!this.errors.items.length)
        } else {
        return this.workloadForm.oppFields.opportunity.Customer_Name &&
          this.workloadForm.oppFields.account.Customer_Region &&
          this.workloadForm.oppFields.account.Customer_Address &&
          this.workloadForm.oppFields.account.Customer_City &&
          this.workloadForm.oppFields.opportunity.Country &&
          this.workloadForm.oppFields.opportunity.Customer_State &&
          this.workloadForm.oppFields.account.Customer_PC &&
          this.workloadForm.oppFields.account.Customer_URL &&
          this.workloadForm.oppFields.opportunity.IndustryVertical &&
          // (this.opportunityRecord.header.RFI_RFP === 1 || this.opportunityRecord.header.RFI_RFP === 0) &&
          (!this.errors.items.length)
        }
      } else {
        console.log('getting')
        if (this.manualRegistration) {
          return this.workloadForm.oppFields.opportunity.SFDC_Oppty_Name &&
          this.workloadForm.oppFields.opportunity.Customer_Name &&
          this.workloadForm.oppFields.account.Customer_Region &&
          this.workloadForm.oppFields.account.Customer_Address &&
          this.workloadForm.oppFields.account.Customer_City &&
          this.workloadForm.oppFields.opportunity.Country &&
          this.workloadForm.oppFields.account.Customer_PC &&
          this.workloadForm.oppFields.account.Customer_URL &&
          this.workloadForm.oppFields.opportunity.IndustryVertical &&
          this.workloadForm.oppFields.opportunity.SignDate &&
          (!this.errors.items.length)
        } else if (this.oppType === '') {
          return this.workloadForm.oppFields.opportunity.SFDC_Oppty_Name &&
          this.workloadForm.oppFields.opportunity.Customer_Name &&
          this.workloadForm.oppFields.account.Customer_Region &&
          this.workloadForm.oppFields.account.Customer_Address &&
          this.workloadForm.oppFields.account.Customer_City &&
          this.workloadForm.oppFields.opportunity.Country &&
          this.workloadForm.oppFields.account.Customer_PC &&
          this.workloadForm.oppFields.account.Customer_URL &&
          this.workloadForm.oppFields.opportunity.IndustryVertical &&
          // (this.workloadForm.oppFields.header.RFI_RFP === 1 || this.workloadForm.oppFields.header.RFI_RFP === 0) &&
          (!this.errors.items.length)
        } else {
          return this.workloadForm.oppFields.opportunity.Customer_Name &&
          this.workloadForm.oppFields.account.Customer_Region &&
          this.workloadForm.oppFields.account.Customer_Address &&
          this.workloadForm.oppFields.account.Customer_City &&
          this.workloadForm.oppFields.opportunity.Country &&
          this.workloadForm.oppFields.account.Customer_PC &&
          this.workloadForm.oppFields.account.Customer_URL &&
          this.workloadForm.oppFields.opportunity.IndustryVertical &&
          // (this.opportunityRecord.header.RFI_RFP === 1 || this.opportunityRecord.header.RFI_RFP === 0) &&
          (!this.errors.items.length)
        }
        
      }
    },
    filterRegion () {
      let oppRegion = this.workloadForm.oppFields.account.Customer_Region
      let oppCountry = this.workloadForm.oppFields.opportunity.Country
      return this.regions.filter(res => {
        return res
      })
      if (!oppRegion && !oppCountry) {
        return this.regions.filter(res => {
          return res
        })
      } else if (!oppRegion && oppCountry != '') {
        let region = this.countries.filter(res => {
          return res.country === oppCountry
        })
        this.workloadForm.oppFields.account.Customer_Region = region[0].region
      }
    },
    filterCountryByRegion () {
      let oppregion = this.workloadForm.oppFields.account.Customer_Region
      let oppCountry = this.workloadForm.oppFields.opportunity.Country
      if (oppregion == 'All Region' || oppregion == null && oppCountry == null) {
        let i = this.countries.filter(res => {
          return res.country
        })
        return i
      }
      if (oppregion != null) {
        let selectedCountry = this.countries.filter(res => {
          return res.region === oppregion
        })
        return selectedCountry
        this.workloadForm.oppFields.opportunity.Country = selectedCountry[0].region
      }
      if (oppCountry != null && oppregion == null) {
        let region = this.countries.filter(res => {
          return res.country === oppCountry
        })
        this.workloadForm.oppFields.account.Customer_Region = region[0].region
        return region
      }
    },
    isStateRequired () {
      if (this.workloadForm.oppFields.opportunity.Country === 'United States of America') {
        return true
      } else {
        return false
      }
    },
    signDate: {
      get: function () {
        return this.workloadForm.oppFields.opportunity.SignDate !== '0000-00-00' ? this.workloadForm.oppFields.opportunity.SignDate : ''
      },
      set: function (date) {
        this.workloadForm.oppFields.opportunity.SignDate = date
      }
    },
    industryVerticalListColumn1() {
      return this.industryVerticalList.filter( (value, index) => index < 10)
    },
    industryVerticalListColumn2() {
      return this.industryVerticalList.filter( (value, index) => index >= 10 && index < 20)
    },
    industryVerticalListColumn3() {
      return this.industryVerticalList.filter( (value, index) => index >= 20)
    },
    calculatedIndustryVertical: {
      get: function () {
        console.log('calculate IV')

        let sfIndustryVertical = this.workloadForm.oppFields.opportunity.IndustryVertical

        if (this.industryVerticalList.includes(sfIndustryVertical)) {
          return sfIndustryVertical
        }
        
        let awsIndustryVerticalMapping = {
          'Financial Services': ['Banking & Capital Markets', 'Insurance'],
          'Software & Internet': ['CME&Tech'],
          'Consumer Goods': ['Consumer Industries & Retail'],
          'Energy - Oil & Gas': ['Energy'],
          'Healthcare': ['Healthcare & Life Sciences'],
          'Manufacturing': ['Manufacturing'],
          'Government': ['Public Sector'],
          'Transportation & Logistics': ['Travel & Transportation']
        }
        // default AWS Industry Vertical
        let mappedIndustryVertical = 'Professional Services'
        
        // if not found default industry is Professional Services
        // loop through mapping
        for (const awsIndustryVertical in awsIndustryVerticalMapping) {
          if (Object.hasOwnProperty.call(awsIndustryVerticalMapping, awsIndustryVertical)) {
            const awsIndustries = awsIndustryVerticalMapping[awsIndustryVertical]
            
            if(awsIndustries.includes(sfIndustryVertical)) {
              mappedIndustryVertical = awsIndustryVertical
            }
          }
        }
        
        this.workloadForm.oppFields.opportunity.IndustryVertical = mappedIndustryVertical

        return mappedIndustryVertical
      },
      set: function (selectedIndustryVertical) {
        // update the state
        this.workloadForm.oppFields.opportunity.IndustryVertical = selectedIndustryVertical
      }
    },
    validateStage () {
      const inValidStages = ['DXC Not Pursued', 'Not Pursued', 'Lost']
      return inValidStages.includes(this.workloadForm.oppFields.opportunity.SFDC_Sales_Stage)
    }
  },
  mounted () {
    // this.$validator.localize(this.dictionary)
  },
  methods: {
    ...mapActions({
      oppregformSubmit: 'user/requestOppreg/submitOppRegForm'
    }),
    ...mapMutations({
      updateRequestor: 'user/requestOppreg/setRequestor',
      updateRegistrationID: 'user/requestOppreg/setRegistrationID',
      updateCustomAccountName: 'user/requestOppreg/setCustomAccountName'
    }),
    onUpdateRegistration () {
      this.updateRegistrationID()
    },
    onCustomerNameChange () {
      if (this.customId || this.isCustName === false) {
        console.log('update account id: ' + this.workloadForm.oppFields.opportunity.Customer_Name)
        this.updateCustomAccountName(this.workloadForm.oppFields.opportunity.Customer_Name)
      }
    },
    onSubmit (e) {
      this.workloadForm.oppFields.opportunity.ESRegion = this.workloadForm.oppFields.account.Customer_Region
      this.updateRequestor(this.$store.state.currentUser)
      let rfi = this.workloadForm.oppFields.header.RFI_RFP === 1 ? 'Yes' : 'No'
      this.workloadForm.oppFields.header.RFI_RFP = rfi
      // https://jira.dxc.com/browse/AGAM-1538
      this.workloadForm.fields.Workload_Title = this.workloadForm.oppFields.opportunity.Opportunity_Id + " : " + this.workloadForm.oppFields.opportunity.SFDC_Oppty_Name
      this.workloadForm.fields.Registration_Id = generateRegistrationID(this.workloadForm.oppFields.opportunity.Opportunity_Id, this.workloadForm.oppFields.opportunity.SFDC_Oppty_Name)

      this.$store.commit('user/requestOppreg/setOppregStep', 'workload')
      // this.oppregformSubmit(this.opportunityRecord)
    },
    goBack(){
      this.$emit('previous')
    },
    onFullView() {
      this.industryVerticalListFullView = true
    },
    onIndustryVerticalRemove() {
      this.workloadForm.oppFields.opportunity.IndustryVertical = ""
    }
  }
}
</script>
<style lang="scss" scoped>
.required {
  color:#f44336;
}
.last-name { margin-top: 24px !important}
.customer-url-note {
  margin-top: 20px;
}

.v-btn-toggle{ margin:10px 0}
      .v-btn-toggle .v-btn{
        padding: 15px 38px;
        opacity: 1;
      }

</style>